export default {
  namespaced: true,
  state () {
    return {
      mobileSidebarOpen: false,
      desktopSubmenuOpen: false,
      miniCartOpen: false,
      searchOpen: false,
      searchAutocompleteResult: null,
      countrySelectorOpen: false,
      mobileProductFilterOpen: false,
      enableDiscountFilter: false,
      currentQueryName: null,
      selectedProductID: '',
      selectedProductFindifyData: null,
      hotspotProductsOpen: false,
      sizeSelectorOpen: false,
      productRestockSidebarOpen: false,

      /**
       * 'Notify me when back in stock' messages
       * They shall all be disabled for now
       */
      notifyMeEnabled: true,
      // Selected item used for restock
      itemId: null,

      /**
       * Overlay
       * Hidden if set to 0
       * The header has a z-index of 10, so set this to either
       * above or below 10 depending on use case
       */
      overlayIndex: 0,
      disableUi: false // disables ui in checkout to wait for api:s to finish
    }
  },
  mutations: {
    /**
     * Mobile Sidebar
     */
    showMobileSidebar (state) {
      // Close everything else
      state.searchOpen = false
      state.countrySelectorOpen = false
      state.desktopSubmenuOpen = false
      state.miniCartOpen = false
      state.mobileProductFilterOpen = false
      state.hotspotProductsOpen = null
      state.productRestockSidebarOpen = false
      state.sizeSelectorOpen = false
      // Open sidebar
      state.mobileSidebarOpen = true
      state.overlayIndex = 11
    },
    hideMobileSidebar (state) {
      state.mobileSidebarOpen = false
      state.overlayIndex = 0
    },

    /**
     * Desktop Submenu
     */
    showDesktopSubmenu (state) {
      // Close everything else
      state.searchOpen = false
      state.countrySelectorOpen = false
      state.mobileSidebarOpen = false
      state.miniCartOpen = false
      state.mobileProductFilterOpen = false
      state.hotspotProductsOpen = null
      state.productRestockSidebarOpen = false
      state.sizeSelectorOpen = false
      // Open submenu
      state.desktopSubmenuOpen = true
      state.overlayIndex = 9
    },
    hideDesktopSubmenu (state) {
      state.desktopSubmenuOpen = false
      state.overlayIndex = 0
    },

    /**
     * Minicart
     */
    showMiniCart (state) {
      // Close everything else
      state.searchOpen = false
      state.countrySelectorOpen = false
      state.mobileSidebarOpen = false
      state.desktopSubmenuOpen = false
      state.mobileProductFilterOpen = false
      state.hotspotProductsOpen = null
      state.productRestockSidebarOpen = false
      state.sizeSelectorOpen = false
      // Open minicart
      state.miniCartOpen = true
      state.overlayIndex = 9
    },
    hideMiniCart (state) {
      state.miniCartOpen = false
      state.overlayIndex = 0
    },

    /**
     * Search
     */
    showSearch (state) {
      // Close everything else
      state.miniCartOpen = false
      state.countrySelectorOpen = false
      state.mobileSidebarOpen = false
      state.desktopSubmenuOpen = false
      state.mobileProductFilterOpen = false
      state.hotspotProductsOpen = null
      state.productRestockSidebarOpen = false
      state.sizeSelectorOpen = false
      // Open search
      state.searchOpen = true
      state.overlayIndex = 8
    },
    hideSearch (state) {
      state.searchOpen = false
      state.overlayIndex = 0
    },

    /**
     * Country Selector
     */
    showCountrySelector (state) {
      // Close everything else
      state.miniCartOpen = false
      state.searchOpen = false
      state.mobileSidebarOpen = false
      state.desktopSubmenuOpen = false
      state.mobileProductFilterOpen = false
      state.hotspotProductsOpen = null
      state.productRestockSidebarOpen = false
      state.sizeSelectorOpen = false
      // Open country selector
      state.countrySelectorOpen = true
      state.overlayIndex = 11
    },
    hideCountrySelector (state) {
      state.countrySelectorOpen = false
      state.overlayIndex = 0
    },

    /**
     * Mobile Product Filter Sidebar
     */
    showMobileProductFilter (state, { queryName, enableDiscountFilter }) {
      // Every time we show the filter menu we replace what's inside it, THAT'S THE ONLY WAY OK!
      state.currentQueryName = queryName
      state.enableDiscountFilter = enableDiscountFilter

      // Close everything else
      state.searchOpen = false
      state.countrySelectorOpen = false
      state.desktopSubmenuOpen = false
      state.miniCartOpen = false
      state.mobileSidebarOpen = false
      state.hotspotProductsOpen = null
      state.productRestockSidebarOpen = false
      state.sizeSelectorOpen = false
      // Open filter
      state.mobileProductFilterOpen = true
      state.overlayIndex = 11
    },
    hideMobileProductFilter (state) {
      state.mobileProductFilterOpen = false
      state.overlayIndex = 0
    },

    /**
     * Hotspot Products Popup
     */
    showHotspotProducts (state, payload) {
      state.currentQueryName = payload.queryName

      // Close everything else
      state.searchOpen = false
      state.countrySelectorOpen = false
      state.desktopSubmenuOpen = false
      state.miniCartOpen = false
      state.mobileSidebarOpen = false
      state.mobileProductFilterOpen = false
      state.productRestockSidebarOpen = false
      state.sizeSelectorOpen = false

      // Open products
      state.hotspotProductsOpen = {
        popupType: payload.popupType,
        popupTitle: payload.popupTitle
      }
      state.overlayIndex = 11
    },
    hideHotspotProducts (state) {
      state.hotspotProductsOpen = null
      state.overlayIndex = 0
    },

    /**
     * Size Selector Popup
     */
    showSizeSelector (state, { productID, findifyData }) {
      state.selectedProductID = productID
      state.selectedProductFindifyData = findifyData

      // Close everything else
      state.searchOpen = false
      state.countrySelectorOpen = false
      state.desktopSubmenuOpen = false
      state.miniCartOpen = false
      state.mobileSidebarOpen = false
      state.mobileProductFilterOpen = false
      state.hotspotProductsOpen = null
      state.productRestockSidebarOpen = false
      // Open Size Selector
      state.sizeSelectorOpen = true
      state.overlayIndex = 11
    },
    hideSizeSelector (state) {
      state.sizeSelectorOpen = false
      state.selectedProductID = ''
      state.selectedProductFindifyData = null
      state.overlayIndex = 0
    },

    /**
     * Product Restock Sidebar
     */
    showProductRestockSidebar (state, itemId) {
      // We can use this here as well
      // state.currentQueryName = queryName
      state.itemId = itemId

      // Close everything else
      state.searchOpen = false
      state.countrySelectorOpen = false
      state.desktopSubmenuOpen = false
      state.miniCartOpen = false
      state.mobileSidebarOpen = false
      state.mobileProductFilterOpen = false
      state.hotspotProductsOpen = null
      state.sizeSelectorOpen = false
      // Open product restock
      state.productRestockSidebarOpen = true
      state.overlayIndex = 11
    },
    hideProductRestockSidebar (state) {
      state.productRestockSidebarOpen = false
      state.overlayIndex = 0
      state.itemId = null
    },

    /**
     * Close All
     */
    closeAll (state) {
      state.miniCartOpen = false
      state.searchOpen = false
      state.mobileSidebarOpen = false
      state.desktopSubmenuOpen = false
      state.countrySelectorOpen = false
      state.mobileProductFilterOpen = false
      state.hotspotProductsOpen = null
      state.sizeSelectorOpen = false
      state.productRestockSidebarOpen = false
      state.overlayIndex = 0
    },

    searchAutocompleteResult (state, result) {
      state.searchAutocompleteResult = result
    },
    disableUi (state, payload) {
      state.disableUi = payload
    }
  },
  actions: {
    setSearchAutocompleteResult ({ commit }, result) {
      commit('searchAutocompleteResult', result)
    },
    showMobileSidebar ({ commit }) {
      commit('showMobileSidebar')
    },
    hideMobileSidebar ({ commit }) {
      commit('hideMobileSidebar')
    },
    showDesktopSubmenu ({ commit }) {
      commit('showDesktopSubmenu')
    },
    hideDesktopSubmenu ({ commit, state }) {
      if (state.desktopSubmenuOpen) {
        commit('hideDesktopSubmenu')
      }
    },
    toggleMiniCart ({ commit, state }) {
      if (!state.miniCartOpen) {
        commit('showMiniCart')
      } else {
        commit('hideMiniCart')
      }
    },
    hideMiniCart ({ commit }) {
      commit('hideMiniCart')
    },
    showSearch ({ commit }) {
      commit('showSearch')
    },
    hideSearch ({ commit }) {
      commit('hideSearch')
    },
    showCountrySelector ({ commit }) {
      commit('showCountrySelector')
    },
    hideCountrySelector ({ commit }) {
      commit('hideCountrySelector')
    },
    showMobileProductFilter ({ commit }, payload) {
      commit('showMobileProductFilter', payload)
    },
    hideMobileProductFilter ({ commit }) {
      commit('hideMobileProductFilter')
    },
    showHotspotProducts ({ commit }, payload) {
      commit('showHotspotProducts', payload)
    },
    hideHotspotProducts ({ commit }) {
      commit('hideHotspotProducts')
    },
    showSizeSelector ({ commit }, payload) {
      commit('showSizeSelector', payload)
    },
    hideSizeSelector ({ commit }) {
      commit('hideSizeSelector')
    },
    showProductRestockSidebar ({ commit }, itemId) {
      commit('showProductRestockSidebar', itemId)
    },
    hideProductRestockSidebar ({ commit }) {
      commit('hideProductRestockSidebar')
    },
    closeAll ({ commit }) {
      commit('closeAll')
    },
    disableUi ({ commit }, payload) {
      commit('disableUi', payload)
    }
  }
}
